module.exports = __webpack_public_path__ + "static/img/template_4.dbaa288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/template_4.png
// module id = /raX
// module chunks = 92